export default __webpack_public_path__ + "static/media/back.88267c19.svg";